// enquiry-module-v1/MasterPages/LeadSourceMaster.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Paper, Typography, TextField, Grid, Button, Checkbox, FormControlLabel, Snackbar, Alert } from '@mui/material';
import { useAuth } from '../../../context/AuthContext';
import { toProperCase } from '../../../utils/formatRows';

export default function LeadSourceMaster({ id, mode, onPopupCancel, connectionString, companyId: propsCompanyId }) {
    // const { id } = useParams();
    const navigate = useNavigate();
    const { user, selectedCompany, loading } = useAuth();

    // Use props instead of context
    const companyId =
        (mode === 'comp' || mode === 'edit')
            ? propsCompanyId
            : selectedCompany?.CompId;

    const fYear = selectedCompany?.financialYear;
    // const username = user?.emailId;
    const userId = user?.UserId || null;

    const [leadSource, setLeadSource] = useState('');
    const [isDefault, setIsDefault] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // Load existing data when in edit mode
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios
                .get(`${connectionString}/api/leadSource/getDetails/${id}`)
                .then(res => {
                    setLeadSource(res.data.LeadSource || '');
                    setIsDefault(res.data.IsDefault === 1);
                })
                .catch(err => console.error('Error fetching LeadSource:', err));
        }
    }, [mode, id, connectionString]);

    const handleCancel = () => {
        // if (onPopupCancel) {
        //     onPopupCancel();
        // } else {
        //     navigate('/main/leadSourceDetail');
        // }
        setSnackbar({ open: true, message: (mode === 'add' || mode === 'comp') ? "Lead Source added successfully" : "Lead Source updated successfully", severity: 'success' });
        if (onPopupCancel) {
            setTimeout(() => { onPopupCancel() }, 600)
        } else {
            navigate(-1);
        }


    };

    const handleSubmit = async e => {
        e.preventDefault();
        const payload = { LeadSource: leadSource, companyId, fYear, userId, IsDefault: isDefault ? 1 : 0 };
        console.log(payload)

        try {
            if (mode === 'add' || mode === 'comp') {
                await axios.post(`${connectionString}/api/leadSource/Insert`, payload);
                // alert('Lead Source added successfully');
                setLeadSource('');
            } else {
                await axios.put(
                    `${connectionString}/api/leadSource/Update/${id}`,
                    payload
                );
                // alert('Lead Source updated successfully');
            }
            // close popup or navigate away
            handleCancel();
        } catch (err) {
            console.error('Error saving Lead Source:', err);
            alert(`Failed to ${mode === 'add' || mode === 'comp' ? 'add' : 'update'} Lead Source`);
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                {mode === 'add' || mode === 'comp' ? 'Add New Lead Source' : 'Edit Lead Source'}
            </Typography>

            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 2 }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Lead Source"
                            required
                            fullWidth
                            size="small"
                            value={toProperCase(leadSource)}
                            onChange={e => setLeadSource(toProperCase(e.target.value))}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isDefault}
                                    onChange={(e) => setIsDefault(e.target.checked)}
                                />
                            }
                            label="Set as Default"
                        />
                    </Grid>


                    <Grid item xs={12} container justifyContent="center" spacing={2}>
                        <Grid item>
                            <Button type="submit" variant="contained" color="primary">
                                {mode === 'add' || mode === 'comp' ? 'Save' : 'Update'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" onClick={onPopupCancel}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })} >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}